export const landingPage = {
    actionCards: {
        title: '¿Cómo deseas presentar la denuncia?',
        onlineForm: {title: 'Denuncia en línea',},
        oralReport: {title: 'Denuncia en telefono',},
        bookMeeting: {title: 'Denuncia en una reunión',},
        askQuestions: {title: 'Formular una pregunta',},
    }
};
